import React, { Component } from 'react';
import { TextInput } from '../shared/TextInput'
import _ from 'lodash'

export default class Discounts extends Component {

  render() {
    return (
      <div>
        <div onClick={this.props.toggleDiscount} style={{ marginTop: 30 }} className='alt-button center-text setting-form' >
          { this.props.discount ? 'Cancel Add Discount' : 'Add Discount Code' }
        </div>
        { this.props.discount &&
          <div style={{ marginTop: 23 }}>
            <TextInput
              inputName='new_discount_name'
              label='Discount Code Name'
              placeholderText='Name'
            />
            <TextInput
              inputName='new_discount_percentage'
              label='Discount Percent'
              placeholderText='Percent (%)'
            />
            <button className='alt-button'>
              Add Discount Code
            </button>
          </div>
        }
          <div style={{ marginBottom: 23 }}>
          <label>
            Discounts
          </label>
          { this.props.discounts && this.props.discounts.map( discount => {
            return (
              <div style={{ maxWidth: 315, justifyContent: 'space-between', display: 'flex', flexDirection: 'row', marginTop: 23 }}>
                <div>
                  { _.startCase(discount['name']) }
                </div>
                <div>
                  { discount['value'] && `${discount['value']}%` || '0%' }
                </div>
              </div>
            )
          })
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/discounts.jsx